import { createSelector } from '@reduxjs/toolkit';
import { selectFx, selectFxRate } from '../../store/selectors';

export const selectParameters = createSelector(selectFxRate, (listState) => listState.parameters);
export const selectFxDailyRates = createSelector(selectFxRate, (listState) => listState.fxDailyRates);
export const selectFxCommon = createSelector(selectFx, (forexRateState) => forexRateState.common);
export const selectItem = createSelector(selectFxRate, (listState) => listState.fxDailyRates);
export const selectEditId = createSelector(selectFxRate, (listState) => listState.editId);
